import { gql } from '@apollo/client';

export const HEADER_FRAGMENT = {
  entry: gql`
    fragment HeaderFragment2 on RootQuery {
      generalSettings {
        title
        description
      }
      primaryMenuItems: menu(id: "Main", idType: NAME) {
        count
        id
        name
        slug
        menuItems(where: { parentDatabaseId: 0 }) {
          nodes {
            id
            title
            url
            cssClasses
            label
            target
            parentId
            childItems {
              nodes {
                id
                title
                url
                cssClasses
                label
                target
                parentId
                childItems {
                  nodes {
                    id
                    title
                    url
                    cssClasses
                    label
                    target
                    parentId
                  }
                }
              }
            }
          }
        }
      }
    }
  `,
  key: 'HeaderFragment2',
};
